<template>
  <div class="menu-item-form">
    <div>
      <vs-input
        class="w-full"
        label="Titulo del menú *"
        v-validate="'required'"
        name="title"
        v-model.lazy="menuForm.text"
        :danger="errors.has('title')"
        :danger-text="errors.first('title')"
      ></vs-input>
    </div>
    <div class="mt-2" v-if="!isRoot">
      <label class="vs-input--label">Menú padre</label>
      <v-select
        :clearable="false"
        v-validate="'required'"
        name="menuParent"
        placeholder="Seleccione"
        label="text"
        class="w-full mt-2"
        v-model.lazy="menuForm.parentMenuItemId"
        :options="menuItems"
        :reduce="item => item.id"
      >
        <div slot="no-options">No hay coincidencias</div>
      </v-select>
    </div>

    <div class="mt-4 mb-2">
      <vs-checkbox v-model="isRoot">Es un elemento raíz</vs-checkbox>
    </div>

    <div>
      <vs-input
        class="w-full mt-2"
        label="Icono"
        name="routeIcon"
        v-model.lazy="menuForm.icon"
      ></vs-input>
      <small>
        <a href="https://fonts.google.com/icons?hl=es-419" target="_blank">
          Revisar la biblioteca de iconos
        </a>
      </small>
    </div>
    <div class="mt-2">
      <label class="vs-input--label">Ruta</label>
      <v-select
        :clearable="false"
        v-validate="'required'"
        name="routeId"
        placeholder="Seleccione"
        label="path"
        class="w-full mt-2"
        v-model.lazy="menuForm.route"
        :options="routes"
      >
        <div slot="no-options">No hay coincidencias</div>
      </v-select>
    </div>

    <div class="mt-2">
      <label>Permisos</label>
      <v-select
        multiple
        label="guard_name"
        v-model="menuForm.route.permissions"
        :options="roles"
        :reduce="role => role.guard_name"
      ></v-select>
    </div>

    <vs-button
      size="small"
      :disabled="errors.count() > 0"
      @click="addItem()"
      class="mt-6">Guardar cambios</vs-button>
  </div>
</template>

<script>
import {NavigationService} from "@/models/Menu/NavigationService";

export default {
  name: "MenuItemCreateForm",
  props: ['roles', 'menuId'],
  data: () => ({
    menuItems: [],
    routes: [],
    isRoot: true,
    menuForm: {
      text: null,
      menuId: null,
      order: 0,
      parentMenuItemId: null,
      icon: null,
      route: {
        permissions: []
      },
    }
  }),
  async mounted() {
    this.$vs.loading();
    try {
      await this.fillParentMenu()
      const {data} = await axios.get(`/api/backoffice/security/route`)
      this.routes = data;
      this.menuForm.menuId = this.menuId;
    } finally {
      this.$vs.loading.close();
    }
  },
  methods: {
    async fillParentMenu() {
      this.$vs.loading();
      try {
        let menu = await NavigationService.find(this.$route.params.menuId);
        this.menuItems = menu.items;
      } finally {
        this.$vs.loading.close();
      }
    },
    async addItem() {
      this.$vs.loading();
      try {
        let result = await NavigationService.addItem(
            this.menuId,
            this.menuForm
        );
        this.successNotif('¡Listo!', 'El submenu se creo correctamente')
        this.$emit("onAddItem", result)
      } catch (e) {
        this.$vs.loading.close();
        this.errorNotif('¡Ups!', 'El submenu no pudo crearse')
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
